import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = ["src", "alt"]

import {Carousel, CarouselContent, CarouselItem} from "@/components/ui/carousel";
import {Card, CardContent} from "@/components/ui/card";
import Autoplay from "embla-carousel-autoplay";
import TablesService from "@/services/tables/tables.service";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingCarousel',
  props: {
    entity: {},
    entityId: {}
  },
  setup(__props: any) {

const props = __props
const photos: any = ref([]);

async function setApi() {
  const res = await TablesService.getAttachments(props.entity, props.entityId, 'photos');
  photos.value = res?.data
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Carousel), {
    class: "relative w-[80%] h-full",
    plugins: [_unref(Autoplay)({
        delay: 6000,
      })],
    onInitApi: setApi
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(CarouselContent), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
            return (_openBlock(), _createBlock(_unref(CarouselItem), {
              key: photo.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(Card), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CardContent), { class: "flex aspect-square items-center justify-center p-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: `data:${photo.mimeType};base64, ${photo.data}`,
                            alt: photo.filename,
                            class: "h-[100%] w-[100%] object-cover rounded-lg"
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["plugins"]))
}
}

})